import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Frap from 'shared/app/components/frap-with-messages';
import PasswordFieldWithValidation from 'shared/app/components/password-field-with-validation';
import { accountsMessages } from 'shared/app/messages';
import messages from './messages';

export const ResetPasswordColumn = ({ fields }) => (
  <React.Fragment>
    <PasswordFieldWithValidation
      field={fields.newPassword}
      label={<FormattedMessage {...accountsMessages.password} />}
    />
    <Frap className="mt6 block" type="submit">
      <FormattedMessage {...messages.resetPasswordSubmit} />
    </Frap>
  </React.Fragment>
);

ResetPasswordColumn.propTypes = {
  fields: PropTypes.object,
};

export default ResetPasswordColumn;
